import { populateProgramGuide, populateProgramGuideCareers, populateProgramCareerResult, getRelatedPrograms,
  getProgramCourseList, getProgramEducation, getProgramCocurricular, getMajorMinors, getLearnerExplorePrograms,
  getLearnerEnrolledProgram,saveEnrollmentStatus, getMajorMinor, setProgramCourseStatus, getAlumniInsightForProgram,
  getTopAlumniCareersForProgram, getTopEmployersForAlumniCareer, getTopAlumniCompaniesForProgram, getTopAlumniIndustriesForProgram,
  getTopAlumniJobTitlesForProgram, putCreatePaymentIntent, putFinalizePaymentIntent,
  getInstitutionPaymentPublicCredentials, getProgramGuideByCodeAndInstitutionId,
  getCheckValidityOfCoupon, getCouponCode, getUserSISProgramMapping, putCreateApplication,
  getResendApplicationLink, getPaymentLink, getAllUserSISProgramMappings,
  putCreateSubscription, deleteSubscription } from '../api'

export const loadProgramGuide = ({ state, commit }, {cipCode, programGuideCode, type}) => {
  return populateProgramGuide(cipCode, programGuideCode, type).then((response) => {
    return response
  })
}

export const loadProgramGuideCareers = ({ state, commit }, {cipCode, code, showAllOccupations}) => {
  return populateProgramGuideCareers(cipCode, code, showAllOccupations).then((response) => {
    commit('LOAD_PROGRAM_GUIDE_CAREERS', response)
    return response
  })
}

export const updateShowAllOccupations = ({ state, commit }, showAllOccupations) => {
  commit('LOAD_SHOW_ALL_OCCUPATIONS', showAllOccupations)
}

export const loadProgramCareerResult = ({ state, commit }, {careerCode, programCode, locationParam}) => {
  return populateProgramCareerResult(careerCode, programCode, locationParam).then((response) => {
    commit('LOAD_PROGRAM_CAREER_RESULT', response)
    return response
  })
}

export const resetProgramCareerResult = ({ state, commit }) => {
  commit('LOAD_PROGRAM_CAREER_RESULT', {})
}

export const loadRelatedPrograms = ({ state, commit }, programId) => {
  return getRelatedPrograms(programId)
}

export const loadProgramCourseList = ({ state, commit }, streamId) => {
  return getProgramCourseList(streamId)
}

export const loadProgramEducation = ({ state, commit }, streamId) => {
  return getProgramEducation(streamId)
}

export const loadProgramCocurricular = ({ state, commit }, streamId) => {
  return getProgramCocurricular(streamId)
}

export const loadMajorMinors = ({ state, commit }, {page, count, name}) => {
  return getMajorMinors(page, count, name)
}

export const loadMajorMinor = ({ state, commit }, {code}) => {
  return getMajorMinor(code)
}

export const loadLearnerExplorePrograms = ({ state, commit }) => {
  return getLearnerExplorePrograms()
}

export const loadLearnerEnrolledProgram = ({ state, commit }) => {
  return getLearnerEnrolledProgram()
}

export const loadSaveEnrollmentStatus = ({ state, commit }, {programCode, status}) => {
  return saveEnrollmentStatus(programCode, status)
}

export const updateProgramCourseStatus = ({ state, commit }, streamId, status) => {
  return setProgramCourseStatus(streamId, status)
}

export const loadProgramAlumniData = ({ state, commit }, programCode) => {
  return getAlumniInsightForProgram(programCode).then(response => {
    commit('LOAD_PROGRAM_ALUMNI_DATA', response)
    return response
  })
}

export const loadTopAlumniCareers = ({ state, commit }, programCode) => {
  return getTopAlumniCareersForProgram(programCode)
}

export const loadTopEmployersForAlumniCareer = ({ state, commit }, {programCode, careerSoc}) => {
  return getTopEmployersForAlumniCareer(programCode, careerSoc)
}

export const loadTopAlumniCompanies = ({ state, commit }, programCode) => {
  return getTopAlumniCompaniesForProgram(programCode)
}

export const loadTopAlumniIndustries = ({ state, commit }, programCode) => {
  return getTopAlumniIndustriesForProgram(programCode)
}

export const loadTopAlumniJobTitles = ({ state, commit }, programCode) => {
  return getTopAlumniJobTitlesForProgram(programCode)
}

export const loadPutCreatePaymentIntent = ({ state, commit }, transactionObj) => {
  return putCreatePaymentIntent(transactionObj)
}

export const loadPutFinalizePaymentIntent = ({ state, commit }, transactionId) => {
  return putFinalizePaymentIntent(transactionId)
}

export const loadGetInstitutionPaymentPublicCredentials = ({ state, commit }, institutionId) => {
  return getInstitutionPaymentPublicCredentials(institutionId)
}

export const loadProgramGuideByCodeAndInstitutionId = ({ state, commit }, {code, cipCode, type, institutionId}) => {
  return getProgramGuideByCodeAndInstitutionId(code, cipCode, type, institutionId)
}

export const loadGetCheckValidityOfCoupon = ({ state, commit }, {couponCode, programCode, pricingPlanId}) => {
  return getCheckValidityOfCoupon(couponCode, programCode, pricingPlanId)
}

export const loadGetCouponCode = ({ state, commit }, couponCode) => {
  return getCouponCode(couponCode)
}

export const loadUserSISProgramMapping = ({ state, commit }, {sisProgramId, sisDegreeId}) => {
  return getUserSISProgramMapping(sisProgramId, sisDegreeId)
}

export const loadCreateApplication = ({ state, commit }, {sisProgramId, sisDegreeId}) => {
  return putCreateApplication(sisProgramId, sisDegreeId)
}

export const loadResendApplicationLink = ({ state, commit }, {sisProgramId, sisDegreeId}) => {
  return getResendApplicationLink(sisProgramId, sisDegreeId)
}

export const loadPaymentLink = ({ state, commit }, {sisProgramId, sisDegreeId}) => {
  return getPaymentLink(sisProgramId, sisDegreeId)
}

export const loadAllUserSISProgramMappings = ({ state, commit }) => {
  return getAllUserSISProgramMappings()
}

export const loadCreateSubscription = ({ state, commit }, transactionObj) => {
  console.log("create subscription got called")
  return putCreateSubscription(transactionObj)
}

export const loadDeleteSubscription = ({ state, commit }, transactionObj) => {
  return deleteSubscription(transactionObj)
}



// WEBPACK FOOTER //
// ./src/app/programguide/vuex/actions.js